export const ADMIN = "Admin";
export const PROVIDER = "Provider";
